import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useBuybackEnabled } from '@backmarket/nuxt-layer-buyback/app/composables/useBuybackEnabled/useBuybackEnabled'
import type { ExperimentName } from '@backmarket/nuxt-module-experiments/config'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

type SwapExperiment = {
  name: ExperimentName
  /** The only variation that turns the swap on for that market. */
  enabledVariation: string
}

const SWAP_EXPERIMENTS_BY_COUNTRY: Partial<
  Record<MarketCountryCode, SwapExperiment>
> = {
  [MarketCountryCode.IT]: {
    name: 'experiment.swapItaly',
    enabledVariation: 'with',
  },
  [MarketCountryCode.JP]: {
    name: 'experiment.tradeInJP',
    enabledVariation: 'enabled',
  },
}

export function useSwapEnabled() {
  const { isBuybackEnabled } = useBuybackEnabled()
  const { market } = useMarketplace()
  const experiments = useExperiments()

  const experiment = SWAP_EXPERIMENTS_BY_COUNTRY[market.countryCode]

  const isSwapEnabled =
    isBuybackEnabled &&
    (!experiment ||
      experiments[experiment.name] === experiment.enabledVariation)

  return { isSwapEnabled }
}
